import { ThemeProviderContext, useThemeLogic } from "@/hooks/use-theme"

type ThemeProviderProps = {
  children: React.ReactNode
  defaultTheme?: "dark" | "light" | "system"
  storageKey?: string
}

export function ThemeProvider({
  children,
  ...props
}: ThemeProviderProps) {
  const value = useThemeLogic()

  return (
    <ThemeProviderContext.Provider value={value}>
      {children}
    </ThemeProviderContext.Provider>
  )
} 